import $ from "jquery";


$(window).on('load', function () {
    const countdownBlocks = document.querySelectorAll(".countdown-clock");

	if (!countdownBlocks.length) return;

	countdownBlocks.forEach((block) => {
		const targetTimestamp = parseInt(block.dataset.countdownTimestamp, 10);

		// if (!targetTimestamp) {
		// 	block.style.display = "none";
		// 	return;
		// }

		const daysTens = block.querySelector("[data-days-tens]");
		const daysOnes = block.querySelector("[data-days-ones]");
		const hoursTens = block.querySelector("[data-hours-tens]");
		const hoursOnes = block.querySelector("[data-hours-ones]");
		const minutesTens = block.querySelector("[data-minutes-tens]");
		const minutesOnes = block.querySelector("[data-minutes-ones]");
		const secondsTens = block.querySelector("[data-seconds-tens]");
		const secondsOnes = block.querySelector("[data-seconds-ones]");

		function setDigits(value, tensEl, onesEl) {
			const padded = String(value).padStart(2, "0");
			if (tensEl) tensEl.textContent = padded.charAt(0);
			if (onesEl) onesEl.textContent = padded.charAt(1);
		}

		function updateCountdown() {
			const now = new Date().getTime();
			const distance = targetTimestamp - now;

			if (distance <= 0) {
				// block.style.display = "none";
				clearInterval(interval);
				return;
			}

			const days = Math.floor(distance / (1000 * 60 * 60 * 24));
			const hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
			const minutes = Math.floor((distance / (1000 * 60)) % 60);
			const seconds = Math.floor((distance / 1000) % 60);

			setDigits(days, daysTens, daysOnes);
			setDigits(hours, hoursTens, hoursOnes);
			setDigits(minutes, minutesTens, minutesOnes);
			setDigits(seconds, secondsTens, secondsOnes);
		}

		updateCountdown();
		const interval = setInterval(updateCountdown, 1000);
	});
    
});

